import { BallBg } from 'components';
import { AthleteFocus, Banner, Shoutout } from './components';

const FanZone = (props) => {
  return (
    <div>
      <BallBg />
      <Banner />
      <Shoutout />
      <AthleteFocus />
      {/*<SocialMedia/>*/}
    </div>
  );
};

export default FanZone;
